<template>
  <div class="card-box demand" v-loading="loading">
    <div class="card-header">最新需求</div>
    <div class="card-main">
      <div class="list">
        <div class="item" v-for="item in demandList" :key="item.id">
          <div class="content">
            <div class="title">{{ item.content }}</div>
            <div class="info">
              <div class="user-info">
                <user-icon :logoPath="item.userLogo" :logoWidth="18"></user-icon>
                <span>{{item.userName}}</span>
              </div>
              <div class="time">{{ item.createdAt }}</div>
            </div>
          </div>
          <div class="btn list-button" @click="fileUploadClick(item)">
            我来提供
            <input type="file" accept=".pdf" @change="fileUpload" @click="e => {e.target.value = '';} " v-if="item.progress <= 0 || item.progress >= 100">
            <el-progress v-else color="#0989c5" class="button-progress" :text-inside="true" :stroke-width="26" :percentage="item.progress"></el-progress>
          </div>
        </div>
      </div>
    </div>

    <el-empty description="暂无数据" :image-size="100" v-if="demandList.length <= 0"></el-empty>

    <el-pagination
      layout="prev, pager, next"
      :total="total"
      :page-size="pageSize"
      :current-page="page"
      class="page-view"
      @current-change="currentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import {WinForm, ApiService} from '@/libs';
import { StandardService, FileService, Message } from '@/service'
import UserIcon from '@/components/icon/user-icon.vue'

export default {
  data() {
    return {
      page: 1,
      pageSize: 4,
      total: 0,
      demandList: [],
      itemDetail: {},
      loading: false,
    }
  },
  components: { UserIcon },
  mounted() {
    this.GetDemands();
    WinForm.md.$on('standard_file_upload', (value) => {
      this.demandList = this.demandList.map(item => {
        if (item.id === value.demandId) {
          item.progress = value.progress;
        }
        return item;
      })
    })
  },
  methods: {
    async GetDemands() {
      this.loading = true;
      const res = await StandardService.GetDemands(this.page, this.pageSize);
      this.loading = false;
      if (res) {
        this.demandList = res.list ? res.list.map(item => ({ ...item, progress: 0 })) : [];
        this.total = res.total;
      }
    },
    currentChange(page) {
      this.page = page;
      this.GetDemands();
    },
    async fileUpload(e) {
      const file = e.target.files[0];
      if (!file.type.includes('/pdf')){
        Message.warning('只能上传pdf格式的文件!')
        return false;
      }
      if (file.size > (50 * 1024 * 1024)) {
        Message.warning('暂不支持上传50M以上的文件!')
        return false;
      }
      const res = await FileService.webFileUpload(`${ApiService.StdApi}/Standard/AddDemandResource`, {
        demandId: this.itemDetail.id,
        file,
        name: file.name,
      }, 'standard_file_upload');
      console.log(res);
      this.currentChange(1);
      this.$parent.resetFileList();
    },
    fileUploadClick(item) {
      this.itemDetail = item;
    }
  }
}
</script>

<style lang="less" scoped>
.card-box {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  position: relative;

  .page-view{
    width: 100%;
    background: #ffffff;
    text-align: right;
    position: absolute;
    left: 0;
    bottom: 0;
  }

  .button-progress{
    position: absolute;
    left: -1px;
    top: -1px;
    width: 88px;
    height: 26px;
  }

  .card-header {
    height: 38px;
    border-bottom: 1px solid rgba(214, 214, 214, 0.5);
    font-size: 16px;
    font-weight: bold;
    color: #2f3848;
    line-height: 38px;
    box-sizing: border-box;
    padding-left: 14px;
    &.border-none {
      border-bottom: none;
    }
  }

  .card-main {
    padding: 0 14px;
    overflow-y: auto;
    margin-bottom: 32px;
  }
}
.demand {
  flex: 1;
}

.list {
  .item {
    padding: 6px 0;

    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(214, 214, 214, 0.5);
    .content {
      flex: 1;
      .title {
        font-size: 14px;
        font-weight: 500;
        color: #2f3748;
      }

      .info {
        margin-top: 2px;
        display: flex;
        font-size: 12px;
        font-weight: 500;
        color: #2f3748;
        align-items: center;
        .user {
          margin-right: 15px;
        }
        .time {
          font-size: 12px;
          font-weight: 500;
          color: #999999;
        }
      }
    }

    .btn {
      width: 86px;
      height: 26px;
      border: 1px solid #0989c5;
      border-radius: 13px;
      font-size: 14px;
      font-weight: bold;
      color: #0989c5;
      box-sizing: border-box;
      line-height: 24px;
      text-align: center;
    }
  }
}
.list-button{
  position: relative;
  input{
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    font-size: 0;
  }
}
.user-info{
  display: flex;
  align-items: center;
  margin-right: 20px;
  img{
    width: 18px;
    margin-right: 4px;
  }
}
</style>
